import { useEffect, useState } from 'react';

/**
 * A `blob:` URL for a picked file, revoked when the file changes or the component goes — so a
 * picture can be shown before it is uploaded without leaking one URL per pick.
 */
export function useObjectUrl(file: File | null): string | null {
  const [url, setUrl] = useState<string | null>(null);
  useEffect(() => {
    if (file === null) {
      setUrl(null);
      return;
    }
    const next = URL.createObjectURL(file);
    setUrl(next);
    return () => {
      URL.revokeObjectURL(next);
    };
  }, [file]);
  return url;
}
